export enum RowAccessControlNamespace {
  Engage = 'engage',
  Operations = 'operations',
}

export enum RowAccessControlObject {
  CaseType = 'engage_case_type',
  Form = 'engage_form',
  Provider = 'operations_provider',
}

export interface IRowAccessObject {
  object: RowAccessControlObject
}

export interface ISingleRowAccessInput {
  singleAccessWith: Partial<Record<RowAccessControlObject, Array<string | undefined>>>
}

/**
 * Input data for row-level list permission checks.
 *
 * @property permittedObjectTypes: Object types that will have ids retrieved from the permission system. Asks the question: "what specific objects can this agent access?"
 */
export interface IRowAccessListInput<T extends RowAccessControlObject> {
  permittedObjectTypes: T[]
}

/**
 * The response from our permission system, containing information on a specific agent's permissions.
 *
 * @property permittedObjectIds: If the agent has general access this will be all `'all'`, otherwise it is the ids this agent has access to (per object type).
 */
export interface IRowAccessPermittedObjectsResult<T extends RowAccessControlObject> {
  permittedObjectIds: RowAccessPermittedObjects<T> | 'all'
}

export type RowAccessPermittedObjects<T extends RowAccessControlObject> = Record<T, string[]>
